// extracted by mini-css-extract-plugin
export default {"infoBox":"item-lock-information-box-module__infoBox--TF4Qc"};